"use strict";
/**
 * Created by Pankaj on 2019-12-27.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrophyTypes = void 0;
var TrophyTypes;
(function (TrophyTypes) {
    TrophyTypes[TrophyTypes["TROPHY_GOLD"] = 0] = "TROPHY_GOLD";
    TrophyTypes[TrophyTypes["TROPHY_SILVER"] = 1] = "TROPHY_SILVER";
    TrophyTypes[TrophyTypes["TROPHY_BRONZE"] = 2] = "TROPHY_BRONZE";
})(TrophyTypes = exports.TrophyTypes || (exports.TrophyTypes = {}));
//# sourceMappingURL=TrophyTypes.js.map